// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"e4e9a671","453":"2a82e7ac","486":"a0207663","582":"d0800255","944":"734095b8"}[chunkId] + ".chunk.js";
};